module.exports = __webpack_public_path__ + "img/payments.9c8efc57.svg";